import styled from 'styled-components';
import { color } from '../../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
`;

// ทาสีแถวตามสถานะสต็อก ใช้ !important เพราะต้องชนะ zebra stripe ของ TableComponent
export const StyledStockTable = styled.div`
  .stock-row-danger > td {
    background-color: #fff1f0 !important;
  }
  .stock-row-danger:hover > td {
    background-color: #ffd8d3 !important;
  }
  .stock-row-warning > td {
    background-color: #fffbe6 !important;
  }
  .stock-row-warning:hover > td {
    background-color: #fff1b8 !important;
  }
`;
